import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M24 46.5c12.426 0 22.5-10.074 22.5-22.5S36.426 1.5 24 1.5 1.5 11.574 1.5 24 11.574 46.5 24 46.5m0 1.5c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M19 33.308c-1.249 0-2.31-.438-3.187-1.314-.875-.875-1.313-1.938-1.313-3.186 0-1.25.438-2.311 1.313-3.187.876-.875 1.938-1.313 3.187-1.313 1.249 0 2.31.438 3.186 1.313.876.876 1.314 1.938 1.314 3.187 0 1.248-.438 2.31-1.314 3.186-.875.876-1.937 1.314-3.186 1.314m13.523-.731-6.342-6.342c-.09.076-.197.15-.322.22a2.26 2.26 0 0 1-.351.164 12.116 12.116 0 0 0-.896-1.04 4.643 4.643 0 0 0 1.804-1.634c.466-.715.7-1.53.7-2.445 0-1.282-.45-2.372-1.347-3.27-.897-.897-1.987-1.346-3.269-1.346s-2.372.45-3.27 1.347c-.897.897-1.346 1.987-1.346 3.269 0 .151.011.302.032.451.021.15.047.296.076.441a3.92 3.92 0 0 0-.737.148c-.269.077-.51.163-.722.258a5.67 5.67 0 0 1-.148-1.298c0-1.708.592-3.154 1.776-4.338 1.185-1.185 2.631-1.777 4.339-1.777 1.708 0 3.154.592 4.338 1.777 1.185 1.184 1.777 2.63 1.777 4.338 0 .717-.119 1.394-.356 2.033a6.308 6.308 0 0 1-.948 1.71l6.266 6.28zm-15.289-1.38L19 29.43l1.75 1.765.639-.623-1.766-1.765 1.765-1.766-.623-.623L19 28.184l-1.765-1.765-.623.623 1.765 1.766-1.765 1.765z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }